var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0B0C0A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.435 45.833c-.553 0-1-.433-1-.966v-41.9c0-.534.447-.967 1-.967.552 0 1 .433 1 .966v41.901c0 .533-.448.966-1 .966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.351 24.95h-41.9c-.534 0-.967-.448-.967-1s.433-1 .966-1h41.901c.534 0 .966.448.966 1s-.432 1-.966 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a17255bfb53f120f3af39c8c70e13f73.svg";
export { ForwardRef as ReactComponent };